import { FC, ReactNode } from 'react'
import classNames from 'classnames'

type TableContainerType = {
  children: ReactNode
  className?: string
}

const ContentContainer: FC<TableContainerType> = ({ children, className }) => {
  return (
    <div
      className={classNames('bg-white shadow-2 rounded-lg', className, {
        'px-5 py-4': !className?.includes('p-'),
      })}
    >
      {children}
    </div>
  )
}

export default ContentContainer
